import { requestsItinerary } from './api'

export type NotificationEjson = {
    host?: string
    messageId?: string
    notificationType?: 'message'
    rid?: string
    sender?: {
        _id: string
        name: string
        username: string
    }
    senderName?: string
    type?: string
    name?: string
}

export type RocketCreateChannelBodyType = {
    user_ids?: number[]
    department_tags?: string[]
    group_tags?: string[]
    channel_name?: string
    channel_name_parts: string[]
    _id: string
}

export type RocketChatBodyType = RocketCreateChannelBodyType & {
    itinerary_id: number
    section_id: number
}

export type RocketCreateDirectChannelBodyType = {
    user_id: number
    user_id2: number
    pending?: boolean
    fullWidth?: boolean
    past?: boolean
}

export type RocketJoinItinChannelsBodyType = {
    user_id: string
}

export type RocketRemoveUsersFromChannelBodyType = {
    user_ids: string[]
    channel_id: string
}

export interface IRCChannel {
    id: string
    itinerary_id: string
    section_id: string
    json_data: IChannelData
    channel_id: string
}
export interface IChannelData {
    channel_name: string
    user_ids?: number[]
    group_tags?: string[]
    department_tags?: string[]
    _id: string
}
export interface IRCUserInfo {
    _id: string
    name: string
    emails: IRCEmailsObject[]
    status?: string
    statusConnection?: string
    username?: string
    utcOffset?: number
    active?: boolean
    roles?: string[]
    settings?: any
    customFields?: any
    avatarUrl?: string
}

export interface IRCEmailsObject {
    address: string
    verified: boolean
}
export interface IRCUser {
    _id: string
    username: string
    type: string
    status: string
    active: boolean
    name: string
    customFields?: CustomFields
    avatarETag?: string
    nameInsensitive: string
}

export interface CustomFields {
    avatarUrl: null | string
    globalID: null | string
    wpUserID: number
}

export const RocketAPI = {
    createChannel: async (body: RocketChatBodyType): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/createChannel',
            body,
            { timeout: 7000 }
        )
        return resp
    },
    createGroupChannel: async (
        body: RocketCreateChannelBodyType
    ): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/createGroupChannel',
            body,
            { timeout: 7000 }
        )
        return resp
    },
    deleteGroupChannel: async (body: { roomId: string }): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/deleteGroupChannel',
            body,
            { timeout: 7000 }
        )
        return resp
    },
    createDirectChannel: async (
        body: RocketCreateDirectChannelBodyType
    ): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/createDirectChannel',
            body,
            { timeout: 7000 }
        )
        return resp
    },

    removeUsersFromGroupChannel: async (
        body: RocketRemoveUsersFromChannelBodyType
    ): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/removeUsersFromGroupChannel',
            body
        )
        return resp
    },
    addUsersToChannel: async (
        body: RocketRemoveUsersFromChannelBodyType
    ): Promise<any> => {
        const resp = await requestsItinerary.post(
            'rocket/inviteUsersToChannel',
            body
        )
        return resp
    },
}
